(function () {
  function init() {
    var btn = document.getElementById('msStickyBook');
    if (!btn) return;
    var shown = false;
    function onScroll() {
      var past = window.scrollY > (window.innerHeight * 0.85);
      if (past && !shown) { btn.classList.add('is-visible'); shown = true; }
      else if (!past && shown) { btn.classList.remove('is-visible'); shown = false; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();